export default class {

    constructor() {

        this.breakpoints = JSON.parse(document.head.querySelector('meta[name="breakpoints"]').content);

        this.update();

        window.addEventListener(
            'resize',
            window._.debounce(() => { this.update() }, 500)
        );

    }

    update() {

        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.media = this.breakpoint();

        EventHandler.fire('window-resized', {
            media: this.media,
            width: this.width,
            height: this.height
        });
    }

    breakpoint() {

        if (this.width > this.breakpoints.xlarge -1) {
            return 'xlarge';
        } else if (this.width > this.breakpoints.large -1) {
            return 'large';
        } else if (this.width > this.breakpoints.medium -1) {
            return 'medium';
        } else {
            return 'small';
        }

    }

}